import React from 'react';
import {useNavigate} from "react-router-dom";
import {OrderType} from "../../../../services/Api/types";
import OrderTypeIcon from "../../../../components/Common/OrderTypeIcon";
import {useTranslation} from "react-i18next";
import {ReactComponent as ArrowRightIco} from "../../../../../images/icons/arrow-right.svg";
import {SessionState} from "../../../../services/Session/types";

interface Props {
    link: string;
    orderType: OrderType;
    session: SessionState;
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const MultistoreOrderTypesModalElement = ({link, orderType, session, setShowAddressModal}: Props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const handleClick = () => {
        if(orderType === OrderType.DELIVERY && !session.full_address) {
            setShowAddressModal(true);
            return;
        }
        navigate(`${link}/${orderType}`);
    }

    const isDisabled = () => {
        if (orderType === OrderType.DELIVERY && !session.in_delivery_area && session.full_address) {
            return true;
        }

        return false;
    }

    const getDisabledHelpText = () => {
        if(isDisabled()) {
            switch(orderType) {
                case OrderType.DELIVERY:
                    return t("modules.multistore.field.your_address_is_not_available.title");
                default:
                    return "";
            }
        }

        return "";
    }

    return (
        <button onClick={handleClick} className="btn btn-lg btn-default btn-nav w-100" disabled={isDisabled()}>
            <OrderTypeIcon orderType={orderType}/>
            <div className="d-flex flex-column align-items-start">
                <h1 className="h6 mb-0">
                    {t(`enums.order.type.${orderType}`)}
                </h1>
                {getDisabledHelpText() && <small className="text-danger opacity-100">{getDisabledHelpText()}</small>}
            </div>
            <ArrowRightIco/>
        </button>
    )
}

export default MultistoreOrderTypesModalElement;